import React, { Component } from "react";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../Loader";
import ErrorText from "../error-success/ErrorText";

// Utils
import { handleKeyPress } from "../../../utils/forms/inputHandling";

const initialState = {
	vimeoID: "",
	survey_url: ""
};

class AddNewTrainingVideoSurveysItemDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: {
				...initialState
			}
		};
	}

	/*
	 * Only update when the dialog is shown
	 */
	shouldComponentUpdate(props) {
		if (!props.show && !this.props.show) return false;
		return true;
	}

	/*
	 * Need to clear out the current title when the dialog closes
	 */
	static getDerivedStateFromProps(props, state) {
		if (props.show === false) {
			return {
				data: {
					...initialState
				}
			};
		}
		return state;
	}

	handleInputChange = event => {
		const { id, value } = event.target;

		this.setState({
			data: {
				...this.state.data,
				[id]: value
			}
		});
	};

	render() {
		const { errors } = this.props;

		// Only need one set of buttons because we will close this dialog upon success
		const buttons = [
			{
				type: Button,
				text: "Cancel",
				action: () => this.props.handleClose(),
				disabled: this.props.inProgress
			},
			{
				type: Button,
				text: "Add",
				action: () =>
					this.props.handleAdd({
						vimeoID: this.state.data.vimeoID,
						survey_url: this.state.data.survey_url
					}),
				disabled: this.props.inProgress
			}
		];

		return this.props.show ? (
			<Modal title={"Add New Training Video Survey"} buttons={buttons}>
				{/* Loading */}
				{this.props.inProgress ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					<div>
						<div className="mb2">
							Video's Vimeo ID (Ex. ID for url https://vimeo.com/
							<strong>303788453</strong> is <strong>303788453</strong>):
							<div className="form-field">
								<input
									autoFocus
									type="text"
									id="vimeoID"
									value={this.state.data.vimeoID}
									onChange={this.handleInputChange}
									onKeyPress={e =>
										handleKeyPress(e, this.props.handleAdd, {
											vimeoID: this.state.data.vimeoID,
											survey_url: this.state.data.survey_url
										})
									}
								/>
							</div>
						</div>
						<div className="mb2">
							Url for survey
							<div className="form-field">
								<input
									type="url"
									id="survey_url"
									value={this.state.data.survey_url}
									onChange={this.handleInputChange}
									onKeyPress={e =>
										handleKeyPress(e, this.props.handleAdd, {
											vimeoID: this.state.data.vimeoID,
											survey_url: this.state.data.survey_url
										})
									}
								/>
							</div>
						</div>
						{errors && <ErrorText errors={errors} animate={1} />}
					</div>
				)}
			</Modal>
		) : null;
	}
}

export default AddNewTrainingVideoSurveysItemDialog;



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/AddNewTrainingVideoSurveysItemDialog.js